module.exports = __webpack_public_path__ + "static/media/findaccountpic2.72e48a68.png";